/**
 * @author Arul Vivek
 */
 import service from '../Common/'
 import constants from '../../../settings/shared/constants'
 
 
 function PostProvisioner(ProvisionerData) {
     let jwtToken = localStorage.getItem('accessToken');
     let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
         return service({
             url: constants.api.provisioner.postProvisioner,
             method: 'POST',
             headers: headers,
             data:  ProvisionerData
         }); 
  }

  function UpdateProvisioner(upateData,id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.provisioner.updateProvisioner+id,
            method: 'PUT',
            headers: headers,
            data:  upateData
        }); 
 }


 function getProvisionerById(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.provisioner.getProvisionerById+id,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

function getserviceByProvisionerType(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.provisioner.getServiceByProvisionerType + id,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

function getProvisionerTypes() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + jwtToken }
    return service({
        url: constants.api.provisioner.getProvisionerTypes,
        method: 'GET',
        headers: headers,
        data: ''
    });
}

 function getProvisionerByService(serviceName) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
    return service({
        url: constants.api.provisioner.getprovisionerByService + serviceName,
        method: 'GET',
        headers: headers,
        data:  ''
    }); 
 }

 function getAllProvisioner() {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.provisioner.getAllProvisioner,
            method: 'GET',
            headers: headers,
            data:  ''
        }); 
 }

 function deleteProvisioner(id) {
    let jwtToken = localStorage.getItem('accessToken');
    let headers = {'Content-Type':'application/json', 'Authorization':'Bearer '+jwtToken}
        return service({
            url: constants.api.provisioner.removeProvisioner+id,
            method: 'DELETE',
            headers: headers,
            data:  ''
        }); 
 }
 
  
 //To export authentication function
 const ProvisionerService = {
    PostProvisioner,
    getAllProvisioner,
    getProvisionerByService,
    getProvisionerById,
    deleteProvisioner,
    UpdateProvisioner,
    getserviceByProvisionerType,
    getProvisionerTypes
 }
 
 export default ProvisionerService;
 